<template>
    <section>
        <b-card>
            <b-row>
                <b-col cols="2">
                    <b-card class="text-center" no-body bg-variant="primary">
                        <h6 class="mt-2">POs Due Today</h6>
                        <h1 class="text-link" @click="onNavigate('/shippingreceiving/pos')">{{ itemObj.poDueToday }}</h1>
                        <b-row>
                            <b-col>
                                <h6>Tomorrow: <strong>{{ itemObj.poUpcomingDue }}</strong></h6>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>    
                <b-col>
                    <b-card class="text-center" no-body bg-variant="warning" text-variant="dark">
                        <h6 class="mt-2">POs Past Due</h6>
                        <h1 class="text-link" @click="onNavigate('/shippingreceiving/pos#pastDue')">{{ itemObj.poPastDue }}</h1>
                        <b-row>
                            <b-col>
                                <h6>1 Day: <strong>{{ itemObj.poPastDue1D }}</strong></h6>
                            </b-col>
                            <b-col>
                                <h6><= 5 Days: <strong>{{ itemObj.poPastDue5D }}</strong></h6>
                            </b-col>
                            <b-col>
                                <h6>> 5 Days: <strong>{{ itemObj.poPastDue5DPlus }}</strong></h6>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>    
                <b-col cols="2">
                    <b-card class="text-center" no-body bg-variant="success">
                        <h6 class="mt-2">SOs Due Today</h6>
                        <h1 class="text-link" @click="onNavigate('/shippingreceiving/sos')">{{ itemObj.soDueToday }}</h1>
                        <b-row>
                            <b-col>
                                <h6>Tomorrow: <strong>{{ itemObj.soUpcomingDue }}</strong></h6>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>  
                <b-col>
                    <b-card class="text-center" no-body bg-variant="danger" text-variant="dark">
                        <h6 class="mt-2">SOs Past Due</h6>
                        <h1 class="text-link" @click="onNavigate('/shippingreceiving/sos#pastDue')">{{ itemObj.soPastDue }}</h1>
                        <b-row>
                            <b-col>
                                <h6>1 Day: <strong>{{ itemObj.soPastDue1D }}</strong></h6>
                            </b-col>
                            <b-col>
                                <h6><= 5 Days: <strong>{{ itemObj.soPastDue5D }}</strong></h6>
                            </b-col>
                            <b-col>
                                <h6>> 5 Days: <strong>{{ itemObj.soPastDue5DPlus }}</strong></h6>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>    
            </b-row>
        </b-card>
    </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            itemObj: {
                poUpcomingDue: 0, 
                poDueToday: 0,
                poPastDue: 0,
                poPastDue1D: 0,
                poPastDue5D: 0,
                poPastDue5DPlus: 0,
                soUpcomingDue: 0, 
                soDueToday: 0,
                soPastDue: 0,
                soPastDue1D: 0,
                soPastDue5D: 0,
                soPastDue5DPlus: 0,
            }
        }
    },
    methods: {
        ...mapActions('dashboard', ['getShippingAndReceivingTracking']),
        onNavigate(link) {
            this.$router.push(link); 
        }

    },
    async mounted() {
        this.itemObj = await this.getShippingAndReceivingTracking();
    }   
}
</script>

<style>
.text-link:hover {
  opacity: 0.7;
  cursor: pointer;
}
</style>